.tag {
  display: inline-flex;
  align-items: baseline;
  gap: var(--space-2xs);

  padding: var(--space-3xs) var(--space-xs);

  font-size: var(--size-100);
  font-weight: var(--weight-medium);

  border-radius: var(--radius-pill);
}

.human {
  color: var(--text-muted);
  background-color: var(--surface-sunken);
}

.ai {
  color: var(--accent-strong);
  background-color: var(--accent-soft);

  border: 1px dashed var(--accent);
}

.confidence {
  font-weight: var(--weight-regular);

  color: var(--text-faint);
}
